import React, { useEffect, useState } from "react";
import { SkeletonCard } from "../shared/Skeleton";
import { t } from "../../lib/i18n";

export default function TestimonialsSection({ testimonials, loading }) {
  const [index, setIndex] = useState(0);
  const len = testimonials?.length || 0;

  useEffect(() => {
    if (len < 2) return undefined;
    const id = setInterval(() => setIndex((i) => (i + 1) % len), 8000);
    return () => clearInterval(id);
  }, [len]);

  return (
    <section
      data-testid="home-testimonials-section"
      className="bg-white/40 py-16 sm:py-20"
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-6">
        <h2 className="font-display text-3xl text-[#1A1A1A] sm:text-4xl">
          {t("home.testimonials.title")}
        </h2>

        {loading ? (
          <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
            {[0, 1, 2].map((i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        ) : (
          <>
            {/* Mobile: single slider card */}
            <div className="mt-12 md:hidden">
              {testimonials[index] ? (
                <Quote t={testimonials[index]} />
              ) : null}
              {len > 1 ? (
                <div className="mt-6 flex justify-center gap-2">
                  {testimonials.map((_, i) => (
                    <button
                      key={i}
                      type="button"
                      data-testid={`testimonial-dot-${i}`}
                      aria-label={`Testimonial ${i + 1}`}
                      onClick={() => setIndex(i)}
                      className={[
                        "h-2 w-2 rounded-full transition",
                        i === index ? "bg-[#C8A24B]" : "bg-[#1A1A1A]/15",
                      ].join(" ")}
                    />
                  ))}
                </div>
              ) : null}
            </div>
            {/* Desktop: all three side-by-side */}
            <ul
              data-testid="home-testimonials-list"
              className="mt-12 hidden grid-cols-3 gap-6 md:grid"
            >
              {testimonials.map((tt) => (
                <li key={tt.id}>
                  <Quote t={tt} />
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </section>
  );
}

function Quote({ t: tt }) {
  return (
    <article
      data-testid={`testimonial-card-${tt.id}`}
      className="flex h-full flex-col justify-between rounded-lg border border-[#EAE3D2] bg-white p-7"
    >
      <p className="font-display text-lg leading-relaxed text-[#1A1A1A] sm:text-xl">
        “{tt.quote}”
      </p>
      <footer className="mt-6 border-t border-[#EAE3D2] pt-4">
        <p className="text-sm font-medium text-[#1A1A1A]">{tt.name}</p>
        {tt.role ? (
          <p className="mt-0.5 text-xs uppercase tracking-[0.24em] text-[#1A1A1A]/50">
            {tt.role}
          </p>
        ) : null}
      </footer>
    </article>
  );
}
